module.exports = __webpack_public_path__ + "img/smiley.aafcbd21.svg";